import React, { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../../config';
import PageWrapper from '../PageWrapper'
import routes from '../Routes'
import { Select } from 'antd';
import { connect } from 'react-redux'
import { Tooltip } from 'antd';
import Message from '../AlertComponent/Message'
function RegistrationForm(props) {
    props.loginData && props.history.go(-1);
    const qualification_options = [
        { value: ' B.Arch', label: ' B.Arch' },
        { value: 'B.A.', label: 'B.A.' },
        { value: 'B.A.M.S.', label: 'B.A.M.S.' },
        { value: 'B.B.A.', label: 'B.B.A.' },
        { value: 'B.Com.', label: 'B.Com.' },
        { value: 'B.C.A.', label: 'B.C.A.' },
        { value: 'B.D.S.', label: 'B.D.S.' },
        { value: 'B.Des. / B.D.', label: 'B.Des. / B.D.' },
        { value: 'B.Ed.', label: 'B.Ed.' },
        { value: 'B.E./B.Tech.', label: 'B.E./B.Tech.' },
        { value: 'BFA / BVA', label: 'BFA / BVA' },
        { value: 'B.F.Sc./ B.Sc. (Fisheries).', label: 'B.F.Sc./ B.Sc. (Fisheries).' },
        { value: 'B.H.M.S.', label: 'B.H.M.S.' },
        { value: 'L.L.B.', label: 'L.L.B.' },
        { value: 'B.Lib. / B.Lib.Sc.', label: 'B.Lib. / B.Lib.Sc.' },
        { value: 'B.M.C. / B.M.M.', label: 'B.M.C. / B.M.M.' },
        { value: 'M.B.B.S.', label: 'M.B.B.S.' },
        { value: 'B.Pharm / B.Pharma.', label: 'B.Pharm / B.Pharma.' },
        { value: 'B.P.Ed.', label: 'B.P.Ed.' },
        { value: 'B.P.T.', label: 'B.P.T.' },
        { value: 'B.Sc.', label: 'B.Sc.' },
        { value: 'BSW / B.A. (SW)', label: 'BSW / B.A. (SW)' },
        { value: 'B.V.Sc. & A.H. / B.V.Sc', label: 'B.V.Sc. & A.H. / B.V.Sc' },
        { value: 'M.D.', label: 'M.D.' },
        { value: 'Pharm.D', label: 'Pharm.D' },
        { value: ' Ph.D.', label: ' Ph.D.' },
        { value: 'D.M.', label: 'D.M.' },
        { value: 'M.Arch.', label: 'M.Arch.' },
        { value: 'M.A.', label: 'M.A.' },
        { value: 'M.B.A.', label: 'M.B.A.' },
        { value: 'M.Ch.', label: 'M.Ch.' },
        { value: 'M.Com.', label: 'M.Com.' },
        { value: 'M.C.A.', label: 'M.C.A.' },
        { value: 'M.D.S.', label: 'M.D.S.' },
        { value: 'M.Des./ M.Design.', label: 'M.Des./ M.Design.' },
        { value: 'M.Ed.', label: 'M.Ed.' },
        { value: 'M.E./ M.Tech.', label: 'M.E./ M.Tech.' },
        { value: 'MFA / MVA', label: 'MFA / MVA' },
        { value: 'L.L.M.', label: 'L.L.M.' },
        { value: 'M.Lib./ M.Lib.Sc.', label: 'M.Lib./ M.Lib.Sc.' },
        { value: 'M.M.C / M.M.M.', label: 'M.M.C / M.M.M.' },
        { value: 'M.Pharm', label: 'M.Pharm' },
        { value: 'M.Phil.', label: 'M.Phil.' },
        { value: 'M.P.Ed. / M.P.E.', label: 'M.P.Ed. / M.P.E.' },
        { value: 'M.P.T.', label: 'M.P.T.' },
        { value: 'M.Sc.', label: 'M.Sc.' },
        { value: 'M.S.W. / M.A. (SW)', label: 'M.S.W. / M.A. (SW)' },
        { value: 'M.Sc. (Agriculture)', label: 'M.Sc. (Agriculture)' },
        { value: 'M.S.', label: 'M.S.' },
        { value: 'M.V.Sc.', label: 'M.V.Sc.' },
    ]
    const [state, setState] = useState({
        email: "",
        password: "",
        confirmPassword: "",
        firstname: '',
        lastname: '',
        successMessage: null,
        counter: 1, phone: '', qualification: '', selectedFile: "", category: '', error: { message: '', name: '' }, gender: '', skill: '', experience: '', loader: false, successeres: '', success: false
    })
    const [show, setShow] = useState(false);
    const f_name = useRef(null)
    const l_name = useRef(null)
    const email = useRef(null)
    const Passwords = useRef(null)
    const phone = useRef(null)
    const Passwords_c = useRef(null)
    const Qualification = useRef(null)
    const Category = useRef(null)
    const skill = useRef(null)
    const experience = useRef(null)
    const Gender = useRef(null)
    useEffect(() => {
        return () => {
        }
    }, [])
    const handleChange = async (e) => {
        setState(prevState => ({
            ...prevState,
            error: { message: '', name: '' }
        }))
        const { name, value } = e.target
        if (name === "phone") {
            var phone = value.replace(/\D+/g, '')
                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
            setState(prevState => ({
                ...prevState,
                [name]: phone
            }))
        }
        else if (name === "experience") {
            var exp = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
            setState(prevState => ({
                ...prevState,
                [name]: exp
            }))
        } else {
            setState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }
    const sendDetailsToServer = async () => {
        setState((prev) => ({
            ...prev, loader: true, successeres: ""
        }))
        var data = new FormData();
        await data.append("action", "user_register")
        await data.append("first_name", state.firstname)
        await data.append("last_name", state.lastname)
        await data.append("email", state.email)
        await data.append("contact", state.phone)
        await data.append("gender", 1)
        await data.append("qualification", state.qualification)
        await data.append("experience", state.experience)
        await data.append("category", state.category)
        await data.append("skill", state.skill)
        await data.append("resume", state.selectedFile)
        await data.append("password", state.password)
        const requestOptions = {
            method: 'post',
            body: data
        };
        fetch(API_BASE_URL + 'data_process.php', requestOptions)
            .then((response) => response.json())
            .then(async (responseJson) => {
                if (responseJson.success === "true") {
                    setState((prev) => ({
                        ...prev, success: true,
                    }))

                    setTimeout(
                        () => {
                            setShow(false)
                            redirectToHome();
                        },
                        1000
                    );
                }
                await setState((prev) => ({
                    ...prev, loader: false, successeres: responseJson
                }))
                setShow(true)
            })
            .catch((error) => {
                setState((prev) => ({
                    ...prev, loader: false
                }))
            });
    }
    const redirectToHome = () => { props.history.push(routes.home); }
    const onFileChange = event => {
        setState(prevState => ({
            ...prevState,
            error: { message: '', name: "" }
        }))
        var file = event.target.files[0]
        setState(prevState => ({
            ...prevState,
            selectedFile: file
        }))
    };
    const { Option } = Select;



    function handleskillChange(value, name) {
        setState(prevState => ({
            ...prevState,
            [name]: value, error: { message: '', name: "" }
        }))
    }
    const submitallinfo = (e) => {
        e.preventDefault();
        if (state.firstname !== "") {
            if (state.lastname !== "") {
                if (/^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(state.email)) {
                    if (state.password !== "" && state.password.length >= 6) {
                        if (state.password === state.confirmPassword) {
                            if (state.phone.length !== 14) {
                                setState(prevState => ({
                                    ...prevState,
                                    error: { message: "Please enter valid phone number", name: "phone" }
                                }))
                                phone.current.focus();
                            }
                            else {
                                if (state.qualification === "") {
                                    setState(prevState => ({
                                        ...prevState,
                                        error: { message: "Please Select Qualification", name: "Qualification" }
                                    }))
                                    window.scrollTo(0, Qualification.current.offsetTop)
                                } else {
                                    if (state.category === "") {
                                        setState(prevState => ({
                                            ...prevState,
                                            error: { message: "Please Select Category", name: "Category" }
                                        }))
                                        window.scrollTo(0, Category.current.offsetTop)
                                    } else {
                                        if (state.experience === "") {
                                            setState(prevState => ({
                                                ...prevState,
                                                error: { message: "Please Enter experience", name: "experience" }
                                            }))
                                            experience.current.focus();
                                        } else {
                                            if ((state.skill === "") || (state.skill.length === 0)) {
                                                setState(prevState => ({
                                                    ...prevState,
                                                    error: { message: "Please Select skill", name: "skill" }
                                                }))
                                                window.scrollTo(0, skill.current.offsetTop)
                                            } else {
                                                if (state.gender === "") {
                                                    setState(prevState => ({
                                                        ...prevState,
                                                        error: { message: "Please Select Gender", name: "Gender" }
                                                    }))
                                                } else {
                                                    if (state.selectedFile === "") {
                                                        setState(prevState => ({
                                                            ...prevState,
                                                            error: { message: "Please Select Resume", name: "Resume" }
                                                        }))
                                                    } else {
                                                        sendDetailsToServer();
                                                    }
                                                }

                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            setState(prevState => ({
                                ...prevState,
                                error: { message: "Passwords do not match", name: "Passwords_c" }
                            }))
                           
                            Passwords_c.current.focus();
                        }
                    } else {
                        setState(prevState => ({
                            ...prevState,
                            error: { message: "password must be 6 characters in length or longer", name: "Passwords" }
                        }))
                       
                        Passwords.current.focus();
                    }
                } else {
                   
                    setState(prevState => ({
                        ...prevState,
                        error: { message: "Please enter valid email", name: "email" }
                       
                    }))
                   
                    email.current.focus();
                }
            } else {
                setState(prevState => ({
                    ...prevState,
                    error: { message: "Please enter last name", name: "l_name" }
                    
                }))
               
                l_name.current.focus();
            }
        } else {
            setState(prevState => ({
                ...prevState,
                error: { message: "Please enter first name", name: "f_name" }
              

            }))
        
            f_name.current.focus();


        }

    }

    return (
        <PageWrapper title={"signup"}>
            <div class="inner_pages_box w-left">
            <div class="sign_up inner_pages">
                <div class="container">
                    <div class="mdc-title">
                        <h3>Sign up<span>Sign up</span></h3>
                    </div>
                </div>
                <div class="container">
                    <Message show={show} handleClose={() => setShow(false)} message={state.successeres}></Message>
                    <div class="form_wrapper">

                        <div class="row">

                            <div class="col-12">
                                <div class="form_container">
                                    <div class="col_half even">
                                        <div class="input_field">
                                            <label class="txt_title">First name*</label>
                                            <input type="text" name="firstname" value={state.firstname} onChange={handleChange} ref={f_name} />
                                            <p className={"errormessage"}>{state.error.name === "f_name" && state.error.message}</p>
                                        </div>
                                    </div>
                                    <div class="col_half"><div class="input_field">

                                        <label class="txt_title">Last Name*</label><input type="text" name="lastname" value={state.lastname}
                                            onChange={handleChange} ref={l_name} />
                                        <p className={"errormessage"}>{state.error.name === "l_name" && state.error.message}</p>
                                    </div></div>
                                    <div class="full_half"><div class="input_field">
                                        <label class="txt_title">Email*</label>  <input type="email" name="email" value={state.email}
                                            onChange={handleChange} ref={email} />
                                        <p className={"errormessage"}>{state.error.name === "email" && state.error.message}</p>
                                    </div></div>
                                    <div class="col_half even"><div class="input_field">
                                        <label class="txt_title">Password*</label>
                                        <input type="password" name="password" value={state.password}
                                            onChange={handleChange} ref={Passwords} />
                                        <p className={"errormessage"}>{state.error.name === "Passwords" && state.error.message}</p>
                                    </div></div>
                                    <div class="col_half">
                                        <div class="input_field">
                                            <label class="txt_title">Re-type Password*</label>
                                            <input type="password" name="confirmPassword" value={state.confirmPassword}
                                                onChange={handleChange} ref={Passwords_c} />
                                            <p className={"errormessage"}>{state.error.name === "Passwords_c" && state.error.message}</p>
                                        </div>
                                    </div>
                                    <div class="col_half even">
                                        <div class="input_field">
                                            <label class="txt_title">Phone*</label>
                                           
                                            <input type="text" name="phone" value={state.phone}
                                                onChange={handleChange} maxLength={14} ref={phone} />
                                            <p className={"errormessage"}>{state.error.name === "phone" && state.error.message}</p>
                                        </div>
                                    </div>

                                    <div class="col_half ">
                                        <label class="txt_title">Qualification*</label>
                                        <div class={state.error.name === "Qualification" ? "input_field_group ant_select_box div_focus" : "input_field_group ant_select_box"} ref={Qualification}>
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={(value) => handleskillChange(value, "qualification")}
                                            >
                                                {qualification_options.map((option) => (
                                                    <Option key={option.value}>{option.value}</Option>
                                                ))}
                                            </Select>
                                            <p className={"errormessage"}>{state.error.name === "Qualification" && state.error.message}</p>
                                        </div>
                                    </div>
                                    <div class="col_half even">
                                        <label class="txt_title">Category*</label>
                                        <div class={state.error.name === "Category" ? "input_field_group ant_select_box div_focus" : "input_field_group ant_select_box"} ref={Category}>
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={(value) => handleskillChange(value, "category")}
                                            >
                                                {props.allfeild !== '' && props.allfeild.category.map((option) => (
                                                    <Option key={option.j_category}>{option.j_category}</Option>
                                                ))}
                                            </Select>
                                            <p className={"errormessage"}>{state.error.name === "Category" && state.error.message}</p>
                                        </div>
                                    </div>
                                    <div class="col_half">
                                        <div class="input_field">
                                            <label class="txt_title">Experience*</label>
                                            
                                            <input type="text" name="experience" value={state.experience}
                                                onChange={handleChange} ref={experience} />
                                            <p className={"errormessage"}>{state.error.name === "experience" && state.error.message}</p>
                                        </div>
                                    </div>
                                    <div class="full_half even ant-select_cus">
                                        <label class="txt_title">Skills*</label>
                                        <Tooltip placement="top" title={"select multiple skills!"}>
                                        <span><a class="tool_tip" >?</a></span>
                                        </Tooltip>
                                        <div class={state.error.name === "skill" ? "input_field_group ant_select_box div_focus" : "input_field_group ant_select_box"} ref={skill}>
                                            <Select
                                                mode="multiple"
                                                allowClear
                                                style={{ width: '100%' }}
                                                onChange={(value) => handleskillChange(value, "skill")}

                                            >
                                                {props.allfeild !== '' && props.allfeild.skill.map((option) => (
                                                    <Option key={option.j_skill}>{option.j_skill}</Option>
                                                ))}
                                            </Select>
                                            <p className={"errormessage"}>{state.error.name === "skill" && state.error.message}</p>
                                        </div>
                                    </div>
                                    <div class="col_half even ant-select_cus">
                                        <label class="txt_title">Gender*</label>
                                        <div class={state.error.name === "Gender" ? "input_field_group ant_select_box div_focus" : "input_field_group ant_select_box"}>
                                            <div class="ant_radio" ref={Gender}>
                                                <div class="radio">
                                                    <input type="radio" name="gender" id="rd1" onChange={handleChange} value={"2"} checked={state.gender === "2" ? true : false} />
                                                    <label for="rd1" class="radio-label">FeMale</label>
                                                </div>
                                                <div class="radio">
                                                    <input type="radio" name="gender" id="rd2" onChange={handleChange} value={"1"} checked={state.gender === "1" ? true : false} />
                                                    <label for="rd2" class="radio-label">Male</label>
                                                </div>

                                            </div>
                                            <p className={"errormessage"}>{state.error.name === "Gender" && state.error.message}</p>
                                        </div>
                                    </div>
                                    <div class="col_half ant-select_cus">
                                        <label class="txt_title">Resume*</label>
                                        <Tooltip placement="top" title={"only pdf file are allowed!"}>
                                            <span>
                                        <a class="tool_tip" >?</a>
                                        </span>
                                        </Tooltip>
                                        <div class="input_field_group ant_select_box" >
                                            <div class="custom-file ant_radio">
                                                <input type="file" class="custom-file-input" name="resume" id="inputGroupFile01"
                                                    accept="application/pdf" onChange={onFileChange} accept="application/pdf" style={{ "display": "none" }} />
                                                <label class="custom-file-label" for="inputGroupFile01">{state.selectedFile === "" ? "Choose file" : state.selectedFile.name}</label>
                                            </div>
                                            <p className={"errormessage"}>{state.error.name === "Resume" && state.error.message}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="siteBtn_box">
                            <input class="button" type="submit" value="Register" onClick={submitallinfo} disabled={state.loader} style={{ opacity: state.loader ? 0.5 : 1 }} />
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </PageWrapper>
    )
}
const mapStateToProps = (state) => {
    return {
        loginData: state.list.login,
        allfeild: state.list.allfeild
    };
};
export default connect(mapStateToProps)(RegistrationForm);
//export default withRouter(RegistrationForm);